import React from 'react';
import { resetPasswordSetNewSuccessStep as resetPasswordLocales } from 'globals/locales/registration';
import FsAlertBoard from 'ui-elements/alerts/FsAlertBoard';
import { ReactComponent as PasswordChangedIcon } from 'assets/images/reset-password/password-changed.svg';
import Routes from 'routes';

const ResetPasswordSetNewSuccessStep: React.FC = () => {
  return (
    <FsAlertBoard
      title={resetPasswordLocales.title}
      maxWidth={440}
      icon={<PasswordChangedIcon />}
      url={Routes.LOGIN}
      buttonLabel={resetPasswordLocales.buttonLabel}
    >
      {resetPasswordLocales.description}
    </FsAlertBoard>
  );
};

export default ResetPasswordSetNewSuccessStep;
